import { request3 } from '../../request3'

export function updateTagName(tagId, tagName) {
  return request3({
    url: `/admin/update-tag/${tagId}/${tagName}`
  })
}
